// Ride/Dawn compatible
(function () {
  const FORMS_SEL = 'form[action="/cart/add"], form[data-type="add-to-cart-form"]';
  const jsonHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  const overlay = document.getElementById('nda-cart-overlay');
  const drawer  = document.getElementById('nda-cart-drawer');
  const itemsEl = document.getElementById('nda-cart-items');
  const subtotalEl = document.getElementById('nda-cart-subtotal');
  const successEl = document.getElementById('nda-cart-success');

  function bindForms() {
    document.querySelectorAll(FORMS_SEL).forEach((form) => {
      if (form.dataset.ndaBound === '1') return;
      form.dataset.ndaBound = '1';
      form.addEventListener('submit', async (e) => {
        if (!window.fetch) return; // laisse le fallback POST marcher
        e.preventDefault();

        const submitBtn = form.querySelector('[type="submit"]');
        const idInput   = form.querySelector('[name="id"]');
        const qtyInput  = form.querySelector('[name="quantity"]');
        const variantId = idInput && idInput.value;
        const qty       = qtyInput && qtyInput.value ? parseInt(qtyInput.value,10) : 1;
        if (!variantId) return;

        lock(submitBtn, true);
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify({ id: variantId, quantity: Math.max(1, qty) }),
            credentials: 'same-origin'
          });
          if (!res.ok) {
            const text = await res.text();
            let msg = 'Impossible d’ajouter cet article.';
            try { const data = JSON.parse(text); msg = data?.description || data?.message || msg; } catch(_){}
            showSuccess(false, msg);
            return;
          }
          await refreshCart();
          showSuccess(true, 'Ajouté au panier ✔');
          openDrawer();
        } catch (err) {
          showSuccess(false, 'Problème réseau. Réessaie.');
          console.error('[NDA] add.js error', err);
        } finally {
          lock(submitBtn, false);
        }
      });
    });
  }

  function lock(btn, state) {
    if (!btn) return;
    btn.disabled = !!state;
    btn.setAttribute('aria-busy', state ? 'true' : 'false');
  }

  function showSuccess(ok, message) {
    if (!successEl) return;
    successEl.textContent = message;
    successEl.style.background = ok ? 'rgba(46,160,67,.15)' : 'rgba(176,0,32,.15)';
    successEl.style.color = ok ? '#2ea043' : '#b00020';
    successEl.hidden = false;
    setTimeout(() => { successEl.hidden = true; }, 2500);
  }

  async function refreshCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
    if (!r.ok) return;
    const cart = await r.json();
    renderCart(cart);
    updateCount(cart.item_count);
  }

  function updateCount(count) {
    const els = document.querySelectorAll('[data-cart-count], .cart-count-bubble .text, #cart-icon-bubble .text');
    els.forEach(el => el.textContent = count);
    const bubble = document.querySelector('#cart-icon-bubble');
    if (bubble) bubble.classList.toggle('hidden', count === 0);
  }

  function renderCart(cart) {
    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="nda-empty">Votre panier est vide.</div>';
      subtotalEl.textContent = '—';
      return;
    }
    itemsEl.innerHTML = cart.items.map(li => {
      const options = (li.options_with_values || []).map(o => `${o.name}: ${o.value}`).join(' · ');
      const img = li.image ? `<img src="${li.image}" alt="">` : `<div style="width:64px;height:64px;background:rgba(255,255,255,.06);border-radius:8px;"></div>`;
      return `
        <div class="nda-item" data-key="${li.key}">
          ${img}
          <div>
            <div class="nda-item__title">${li.product_title}</div>
            ${options ? `<div class="nda-item__options">${options}</div>` : ''}
            <div class="nda-item__qty">
              <button class="nda-qty-btn" data-delta="-1" aria-label="Diminuer">−</button>
              <span>${li.quantity}</span>
              <button class="nda-qty-btn" data-delta="1" aria-label="Augmenter">+</button>
              <button class="nda-qty-btn" data-remove="1" title="Retirer">×</button>
            </div>
          </div>
          <div class="nda-item__price">${Shopify.formatMoney(li.final_line_price)}</div>
        </div>`;
    }).join('');
    subtotalEl.textContent = Shopify.formatMoney(cart.items_subtotal_price);

    // Bind qty buttons
    itemsEl.querySelectorAll('.nda-item').forEach(row => {
      const key = row.getAttribute('data-key');
      row.querySelectorAll('.nda-qty-btn').forEach(btn => {
        btn.addEventListener('click', async () => {
          let quantity = null;
          const delta = btn.dataset.delta ? parseInt(btn.dataset.delta,10) : 0;
          const remove = btn.dataset.remove ? true : false;
          const currentQty = parseInt(row.querySelector('span').textContent, 10);
          if (remove) quantity = 0;
          else quantity = Math.max(0, currentQty + delta);
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify({ id: key, quantity }),
            credentials: 'same-origin'
          });
          await refreshCart();
        });
      });
    });
  }

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.hidden = false; overlay.hidden = false;
    drawer.classList.add('is-open');
    overlay.addEventListener('click', closeDrawer, { once: true });
    const closeBtn = drawer.querySelector('.nda-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer, { once: true });
  }
  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    setTimeout(() => { drawer.hidden = true; overlay.hidden = true; }, 200);
  }

  // Initial bind + rebinder si sections réinjectées
  document.addEventListener('DOMContentLoaded', () => { bindForms(); });
  document.addEventListener('shopify:section:load', () => { bindForms(); });
})();
